(() => {
  const startedAt = Date.now();
  const minimumDisplay = 650;

  const dismissLoader = () => {
    const loader = document.getElementById('toak-page-loader');
    if (!loader) return;

    const wait = Math.max(0, minimumDisplay - (Date.now() - startedAt));
    window.setTimeout(() => {
      loader.classList.add('is-leaving');
      window.setTimeout(() => loader.remove(), 450);
    }, wait);
  };

  if (document.readyState === 'complete') {
    dismissLoader();
  } else {
    window.addEventListener('load', dismissLoader, { once: true });
    window.setTimeout(dismissLoader, 2600);
  }
})();
